import React, { Children } from 'react'
import { Card } from 'antd'

const CardComponent = ({children,title,extra,className}) => {
  return (
    <Card className={className} title={title} extra={extra}>{children}</Card>
  )
}

export default CardComponent